import React from 'react';
import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom';
import Menu from './Components/Menu'
import Home from './Pages/Home/Home';
import AcumaticaErp from './Pages/AcumaticaErp/AcumaticaErp';
import Service from './Pages/Services/Service';
import HrPayroll from './Pages/HrPayroll/HrPayroll';
import Contact from './Pages/Contact/Contact';
import Work from './Pages/Work/Work';

import Delete from './Pages/Work/Delete';
import Jobs from './Pages/Work/Jobs';
import Apply from './Pages/Work/Apply';
import Acumatica from './Pages/AcumaticaErp/Acumatica';
import Palladium from './Pages/AcumaticaErp/Palladium';
import Construction from './Pages/AcumaticaErp/Construction';
import { Distribution } from './Pages/AcumaticaErp/Distribution';
import Manufacturing from './Pages/AcumaticaErp/Manufacturing';
import Commerce from './Pages/AcumaticaErp/Commerce';
import General from './Pages/AcumaticaErp/General';
import Consulting from './Pages/Services/Consulting';
import Training from './Pages/Services/Training';
import Support from './Pages/Services/Support';
import Referral from './Pages/Referral/Referral';

function App() {
  return (
    <BrowserRouter>
      <div style={{ display: 'flex' }}>
        <Menu />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="AcumaticaErp" element={<AcumaticaErp />} />
          <Route path="Acumatica" element={<Acumatica />} />
          <Route path="Construction" element={<Construction />} />
          
          {/* New SEO-friendly URLs */}
          <Route path="inventory-management-software" element={<Distribution />} />
          <Route path="palladium-accounting-software" element={<Palladium />} />
          <Route path="hr-payroll-software" element={<HrPayroll />} />
          <Route path="erp-consulting" element={<Consulting />} />
          
          {/* 301 Redirects from old URLs to new URLs */}
          <Route path="Distribution" element={<Navigate to="/inventory-management-software" replace />} />
          <Route path="Palladium" element={<Navigate to="/palladium-accounting-software" replace />} />
          <Route path="Payspace" element={<Navigate to="/hr-payroll-software" replace />} />
          <Route path="Consulting" element={<Navigate to="/erp-consulting" replace />} />
          
          <Route path="Manufacturing" element={<Manufacturing />} />
          <Route path="Commerce" element={<Commerce />} />
          <Route path="General" element={<General />} />
          <Route path="Service" element={<Service />} />
          <Route path="Career" element={<Work />} />
          <Route path="Contact" element={<Contact />} />  
          <Route path="delete" element={<Delete />} />
          <Route path="Jobs" element={<Jobs />} />
          <Route path="Apply" element={<Apply />} />
          <Route path="Training" element={<Training />} />
          <Route path="Support" element={<Support />} />
          <Route path="referral" element={<Referral />} />
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;
